<div class="copyright" style="color:#fff; font-size: 11px; text-align: center; margin-top: 20px;">
  {{ 'Coded and designed with love by' | translate }}
  <br/>
  <a style="color:#fff;" href="mailto:antho.brioit@gmail.com">Anthony Brioit</a>
</div>



<div class="container-home-button" *ngIf="router.url !== '/categories'">
  <a routerLink="/" class="addToFavorites">
    <mat-icon>home</mat-icon>
    <span>{{ 'home' | translate }}</span>
  </a>
</div>
